import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../config/api';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { isActiveMemberForSeason } from '../utils/memberStatus';
import InactiveMemberNotice from '../components/InactiveMemberNotice';
import PageMeta from '../components/PageMeta';
import './JuventusCard.css';

const JuventusCard = () => {
  const { user } = useAuth();
  const { t, locale, language } = useLanguage();
  const [myRequests, setMyRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }
    api.get('/juventus-card-requests/mine')
      .then((res) => setMyRequests(Array.isArray(res.data) ? res.data : []))
      .catch(() => setMyRequests([]))
      .finally(() => setLoading(false));
  }, [user]);

  const latestRequest = myRequests.length > 0 ? myRequests[0] : null;
  const canRequestCard = user && isActiveMemberForSeason(user);

  const statusLabel = (status) => {
    if (status === 'pending') return t('juventusCard.statusPending');
    if (status === 'processed') return t('juventusCard.statusProcessed');
    return status;
  };

  return (
    <div className="juventus-card-page">
      <PageMeta
        title={t('seo.juventusCard.title')}
        description={t('seo.juventusCard.description')}
        path="/juventus-card"
        locale={language}
      />
      <div className="container">
        <h1 className="page-title">{t('juventusCard.title')}</h1>

        <div className="juventus-card-content">
          <div
            className="juventus-card-intro"
            dangerouslySetInnerHTML={{ __html: t('juventusCard.intro') }}
          />

          {!user && (
            <p className="juventus-card-login-hint">
              {t('juventusCard.loginHint')}
            </p>
          )}

          <InactiveMemberNotice />

          {user && (
            <>
              {loading ? (
                <p className="juventus-card-status-loading">{t('juventusCard.loading')}</p>
              ) : latestRequest ? (
                <div className="juventus-card-status-block">
                  <h2 className="juventus-card-status-title">{t('juventusCard.statusTitle')}</h2>
                  <p className="juventus-card-status-value">
                    <strong>{t('juventusCard.statusLabel')}</strong> {statusLabel(latestRequest.status)}
                  </p>
                  <p className="juventus-card-status-date">
                    {t('juventusCard.requestDate')}{' '}
                    {latestRequest.createdAt
                      ? new Date(latestRequest.createdAt).toLocaleDateString(locale)
                      : '—'}
                  </p>
                  {canRequestCard && (
                    <Link
                      to="/juventus-card/perte"
                      state={{ juventusCardRequestId: latestRequest._id }}
                      className="btn-juventus-card-lost"
                    >
                      {t('juventusCard.lostCta')}
                    </Link>
                  )}
                </div>
              ) : null}
            </>
          )}

          {canRequestCard ? (
            <div className="juventus-card-cta">
              <p>{t('juventusCard.ctaText')}</p>
              <Link to="/juventus-card/demande" className="btn-request-card">
                {t('juventusCard.ctaRequest')}
              </Link>
            </div>
          ) : !user ? (
            <p className="juventus-card-login-hint">{t('juventusCard.inactiveHint')}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default JuventusCard;

